import React from 'react'
import PropTypes from 'prop-types'
import Title from 'shared/components/Title'

const Integration = ({ children }) => (
  <div>
    <Title title="Integrations" />
    {children}
  </div>
)

Integration.propTypes = {
  children: PropTypes.object,
}

export default Integration



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/pages/Admin/Integrations/Layout.js